import moment from "moment";
import React, { useState } from "react";
import Avatar from "react-avatar";
import { IoMdClose } from "react-icons/io";

const Details = ({ isOpen, data, onClose }) => {
  const [step, setStep] = useState(1);

  const thumbnailUrl = data?.post?.files
    ? data?.post?.files[0]?.includes('{"')
      ? JSON.parse(data?.post?.files[0])?.thumbnail_url
      : data?.post?.files[0]
    : data?.post?.files[0];

  console.log("🚀 ~ thumbnailUrl:", thumbnailUrl);

  const url = data?.post?.files
    ? data?.post?.files[0]?.includes('{"')
      ? JSON.parse(data?.post?.files[0])?.url
      : data?.post?.files[0]
    : data?.post?.files[0];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="max-h-[90vh] max-w-[700px] rounded-xl bg-navy-800 px-6 pb-6 text-white shadow-lg">
        <div className="flex justify-end py-3">
          <IoMdClose
            className="cursor-pointer text-2xl text-white"
            onClick={() => {
              if (step === 1) {
                onClose();
              } else {
                setStep(1);
              }
            }}
          />
        </div>
        {step === 1 ? (
          <>
            <p className="text-lg font-bold uppercase text-white">Report For</p>
            <div className="relative mt-3 flex w-full items-center justify-start gap-5 rounded-xl bg-cover">
              <div className="flex h-[120px] w-[120px] flex-col justify-center rounded-full border-[4px] !border-navy-700 bg-pink-400">
                {data?.account?.profilepic ? (
                  <img
                    src={data?.account?.profilepic}
                    alt="Profile"
                    className="h-full w-full rounded-full object-cover"
                  />
                ) : (
                  <Avatar
                    name={data?.account?.name}
                    className="h-full w-full rounded-full"
                  />
                )}
              </div>
              {/* Name and position */}
              <div className="flex max-w-[500px] flex-col">
                <h4 className="text-xl font-bold capitalize text-white">
                  {data?.account?.name ? data?.account?.name : "--"} (
                  {data?.account?.account_type})
                </h4>
                {data?.account?.email && (
                  <p className="text-[16px] text-white">
                    <strong>Email</strong>: {data?.account?.email}
                  </p>
                )}
                {data?.message && (
                  <p className="">
                    <strong>Message</strong>: {data?.message}
                  </p>
                )}
                {data?.account?.address && (
                  <p className="text-[16px] text-white">
                    <strong>Address</strong>: {data?.account?.address}
                  </p>
                )}
                {data?.account?.bio && (
                  <p className="max-h-[200px] overflow-auto text-[16px] text-white">
                    <strong>Bio</strong>: {data?.account?.bio}
                  </p>
                )}
              </div>
            </div>

            {data?.post && data?.report_type === "post" && (
              <>
                <div className="my-5 border-b border-gray-600"></div>
                <div className="mt-5">
                  <h3 className="mb-3 text-lg font-bold uppercase">Post</h3>

                  <div className="flex gap-5">
                    {thumbnailUrl || url ? (
                      <img
                        src={thumbnailUrl ? thumbnailUrl : url}
                        alt="Profile"
                        className="h-32 w-32 cursor-pointer rounded-md object-cover"
                        onClick={() => setStep(2)}
                      />
                    ) : (
                      <Avatar
                        name={data?.reporter?.name}
                        className="h-full w-full rounded-full"
                      />
                    )}

                    <div className="grid max-w-[500px] grid-cols-8 gap-1.5">
                      <p className="col-span-2 h-fit">Description:</p>
                      <p className="col-span-6 h-fit max-h-[200px] overflow-auto">
                        {data?.post?.description}
                      </p>

                      <p className="col-span-2 h-fit">Post Type: </p>
                      <p className="col-span-6 h-fit capitalize">
                        {data?.post?.post_type}
                      </p>

                      <p className="col-span-2 h-fit">Creation Date: </p>
                      <p className="col-span-6 h-fit">
                        {moment(data?.post?.createdAt).format(
                          "DD/MM/YYYY HH:mm"
                        )}
                      </p>

                      <p className="col-span-2 h-fit">Activated: </p>
                      <p className="col-span-6 h-fit">
                        {data?.post?.is_active ? "Yes" : "No"}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* 
            {data?.account && data?.report_type === "account" && (
              <>
                <div className="my-5 border-b border-gray-600"></div>
                <div className="mt-5">
                  <h3 className="mb-3 text-lg font-bold uppercase">Account</h3>

                  <div className="flex gap-5">
                    {data?.account?.profilepic ? (
                      <img
                        src={data?.account?.profilepic}
                        alt="Profile"
                        className="h-32 w-32 rounded-md object-cover"
                      />
                    ) : (
                      <Avatar
                        name={data?.reporter?.name}
                        className="h-full w-full rounded-full"
                      />
                    )}

                    <div className="flex flex-col gap-1.5">
                      <p className="col-span-8 text-xl font-bold capitalize">
                        {data?.account?.name} ({data?.account?.account_type})
                      </p>

                      {data?.account?.email && (
                        <p className="text-[16px] text-white">
                          <strong>Email</strong>: {data?.account?.email}
                        </p>
                      )}
                      {data?.account?.bio && (
                        <p className="">
                          <strong>Bio</strong>: {data?.account?.bio}
                        </p>
                      )}
                      {data?.account?.address && (
                        <p className="text-[16px] text-white">
                          <strong>Address</strong>: {data?.account?.address}
                        </p>
                      )}
                      {data?.account?.createdAt && (
                        <p className="text-[16px] text-white">
                          <strong>Creation Date</strong>:{" "}
                          {moment(data?.account?.createdAt).format(
                            "DD/MM/YYYY HH:mm"
                          )}
                        </p>
                      )}
                      {data?.account?.is_active && (
                        <p className="text-[16px] text-white">
                          <strong>Activated</strong>:{" "}
                          {data?.account?.is_active ? "Yes" : "No"}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )} */}
          </>
        ) : (
          <div className="flex w-full items-center justify-center">
            {thumbnailUrl &&
            [
              ".mp4",
              ".webm",
              ".ogg",
              ".avi",
              ".mov",
              ".wmv",
              ".flv",
              ".mkv",
              ".3gp",
              ".m4v",
            ].some((ext) => url.toLowerCase().endsWith(ext)) ? (
              <video muted controls className="max-h-[80vh] w-fit ">
                <source src={url}></source>
              </video>
            ) : (
              <img src={url} alt="url" className="max-h-[80vh] w-fit " />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Details;
